var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    spacing = _ref.spacing,
    borders = _ref.borders,
    typography = _ref.typography;
  return {
    numberSummaryColor: colors.contrasts.grey125125,
    numberSummaryFontSize: typography.fontSizeMedium,
    numberSummaryFontWeight: typography.fontWeightBold,
    firstNumberSummaryPadding: spacing.xxSmall,
    secondNumberSummaryPadding: spacing.xxSmall,
    verticalDotsBorderWidth: borders.widthSmall,
    verticalDotsBorderColor: colors.contrasts.grey125125
  };
};
export default generateComponentTheme;